import 'babel-polyfill'
import 'scss/component/footer.scss'

$(function () {
  function getCmsNavInfo () {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: '/wuhan-cms/platform/common?platform=wuhan',
        type: 'get',
        success: function (result) {
          resolve(result)
        },
        error: function () {
          resolve({})
        }
      })
    })
  }

//  getCmsNavInfo().then(result => {
//    if (result.code === 0 || result.code === '0') {
//      renderFooter(result.data.footer)
//    }
//  })

  function renderFooter (footerObj) {
    var imgObj = {
      weibo: require('assets/img/common/wb.png'),
      wechat: require('assets/img/common/wechat.png'),
      facebook: require('assets/img/common/facebook.png'),
      twitter: require('assets/img/common/twitter.png'),
      google: require('assets/img/common/google.png'),
      iflytek: require('assets/img/common/iflytek.png'),
      bi_bg: require('assets/img/common/bi_bg.png'),
      beian: require('assets/img/common/beian.png')
    }
    var footerData = JSON.parse(footerObj)
    console.log("foot_data:"+footerData);
    var footerHtml = ''
    footerHtml += `<div class="banner-info" style="background-image: url(${imgObj.bi_bg})">${footerData.welcome.richText}</div>`
    footerHtml += `<div class="footer">
    <div class="footer-top">
      <div class="top-items">
        <img class="footerlogo" src=${footerData.support.logo} />
        <ul class="footer-ul">
    `
    if (footerData.support.weibo) {
      footerHtml += `<li class="item-content"><div class="top-logo"><img class="content-logo" src=${imgObj.weibo} /></div><a href=${footerData.support.weibo} target="_blank" rel="noreferrer">微博</a></li><div class="img-box"><img class="wechat-logo" src=${footerData.support.wechat} /> </div>`
    }
    if (footerData.support.wechat) {
      footerHtml += `<li class="item-content"><div class="top-logo"><img class="content-logo" src=${imgObj.wechat} /></div><a class="wechat-text" href=${footerData.support.wechat} target="_blank" rel="noreferrer">微信</a></li>`
    }
    if (footerData.support.facebook) {
      footerHtml += `<li class="item-content"><div class="top-logo"><img class="content-logo" src=${imgObj.facebook} /></div><a href=${footerData.support.facebook} target="_blank" rel="noreferrer">Facebook</a></li>`
    }
    if (footerData.support.twitter) {
      footerHtml += `<li class="item-content"><div class="top-logo"><img class="content-logo" src=${imgObj.twitter} /></div><a href=${footerData.support.twitter} target="_blank" rel="noreferrer">Twitter</a></li>`
    }
    if (footerData.support.google) {
      footerHtml += `<li class="item-content"><div class="top-logo"><img class="content-logo" src=${imgObj.google} /></div><a href=${footerData.support.google} target="_blank" rel="noreferrer">Google+</a></li>`
    }
    footerHtml += `</ul>
    </div>`
    footerData.linkList.forEach(item => {
      var btHtml = ''
      item.buttons.forEach(bt => {
        btHtml += `<li class="item-content"><a href=${bt.href} target=${bt.target} rel="noreferrer">${bt.title}</a></li>`
      })
      var htmlRes = `<div class="top-items">
          <p class="item-title">${item.title}</p>
          <ul>
            ${btHtml}
          </ul>
        </div>
      `
      footerHtml += htmlRes
    })
    footerHtml += `<div class="top-items">
    <p class="item-title">联系我们</p>
    <div class="contact"><p class="item-number">${footerData.support.phone}</p>
    <p class="item-time">${footerData.support.phoneTime}</p></div>
    <ul>
      <li class="item-content"></li>
      <li class="item-content">技术支持：<a class="work-order" href=${footerData.support.workorder} target="_blank" rel="noreferrer">提交工单</a></li>
      <li class="item-contact">QQ交流群：816241597</li>
  `
    footerData.support.emails.forEach(email => {
      footerHtml += `<li class="item-contact">${email.title}：${email.path}</li>`
    })
    if (footerData.support.bbs) {
      footerHtml += `<li class="item-content">论坛交流：<a href=${footerData.support.bbs} target="_blank">${footerData.support.bbs}</a></li>`
    }
    footerHtml += `</ul>
    </div>
  </div>
  <div class="footer-line"></div>
  <div class="footer-bottom">
  `
    footerData.others.forEach(item => {
      if (item.type === 'pureIcon') {
        footerHtml += `<div class="logo-wrap"><img class="footer-bottom-logo" src=${imgObj.iflytek} /></div>`
      }
      if (item.type === 'text') {
        footerHtml += `<p class="footer-bottom-text">${item.title}</p>`
      }
      if (item.type === 'link') {
        footerHtml += `<a class="footer-bottom-text text-link" href=${item.href} target=${item.target}><img class="icon" src=${imgObj.beian} />${item.title}</a>`
      }
    })
    footerHtml += `</div>
    </div>`
    $('.util-footer').append(footerHtml)
    $('.wechat-text').mouseenter(function () {
      $('.img-box').css('display', 'block')
    })
    $('.wechat-text').mouseleave(function () {
      $('.img-box').css('display', 'none')
    })
  }
})



// WEBPACK FOOTER //
// ./src/js/libs/utils-footer.js